import { Investor } from './Investor'

export const sampleInvestor = (override?: Partial<Investor>): Investor => ({
  sub: 'my-id',
  investorId: 'my-investor-id',
  firstName: 'Jeremy',
  lastName: 'Spring',
  email: 'jitewaboh@lagify.com',
  signedInWithSSO: false,
  changeEmail: {
    emailVerified: true,
  },
  ...override,
})
